import { render } from "./ClaimDetails.vue?vue&type=template&id=d0b1531a&scoped=true"
import script from "./ClaimDetails.vue?vue&type=script&lang=js"
export * from "./ClaimDetails.vue?vue&type=script&lang=js"

import "./ClaimDetails.vue?vue&type=style&index=0&id=d0b1531a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0b1531a"]])

export default __exports__